import * as React from 'react';

import { Styled } from './hero.styles';
import type { HeroProps } from './hero.types';

export const Hero = React.forwardRef<HTMLHeadingElement, HeroProps>(
  (
    {
      children,
      className,
      noMargin,
      size = 'medium',
      sizeConfined,
      sizeWide,
      ...props
    },
    forwardedRef
  ): JSX.Element => (
    <Styled.Hero
      $noMargin={noMargin}
      $size={size}
      $sizeConfined={sizeConfined}
      $sizeWide={sizeWide}
      className={className}
      data-xds="Hero"
      ref={forwardedRef}
      {...props}
    >
      {children}
    </Styled.Hero>
  )
);

Hero.displayName = 'Hero';
